import { useDispatch } from "react-redux";
import { setCoachMe } from "../store/reducers/coachMe";
import { removeStorageItem } from "../utils/localStorage";

export const useMe = () => {
  const dispatch = useDispatch();

  const resetMe = () => {
    dispatch(setCoachMe(undefined));
    removeStorageItem("coachMe");
  };

  return {
    resetMe,
  };
};
